module.exports = __webpack_public_path__ + "static/media/tpn-ce-wire-1.8701723b.png";